import ConfirmModal from '@/components/ConfirmModal';
import { Icons } from '@/components/icons';
import { Link } from '@/components/primitives/Link';
import { Typography } from '@/components/primitives/Typography';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import {
  deletePurchaseFlowBooking,
  resetPurchase,
} from '@/features/purchase/purchaseActions';
import { purchaseFlowBookingSelector } from '@/features/purchase/purchaseSelectors';
import { useThemedColors } from '@/hooks/useThemedColors';
import { TransText } from '@/i18n/trans/text';
import { persistor } from '@/store';
import { useDispatch, useSelector } from '@/store/utils';
import { cn } from '@/utils/cn';
import { getTenantConfiguration } from '@/utils/tenant';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const Logo = () => {
  const dispatch = useDispatch();
  const selectedTenant = useSelector(tenantSelector);
  const TenantIcon = Icons[selectedTenant.value];
  const configuration = getTenantConfiguration(selectedTenant.value);
  const location = useLocation();
  const userIsInCheckout = location.pathname === '/purchase/checkout';
  const { getLinkColors } = useThemedColors();
  const booking = useSelector(purchaseFlowBookingSelector);

  const handleRedirectionToConfiguredUrl = useCallback(async () => {
    await dispatch(deletePurchaseFlowBooking(booking!.id!)).unwrap();
    dispatch(resetPurchase());
    void persistor.purge();
    window.location.assign(configuration!.webPageUrl!);
  }, [booking, configuration, dispatch]);

  if (!configuration?.webPageUrl) {
    return <TenantIcon />;
  }

  if (configuration.webPageUrl && userIsInCheckout) {
    return (
      <ConfirmModal
        title={<TransText i18nKey="cancelPurchase" />}
        description={
          <Typography variant="paragraph">
            <TransText i18nKey="areYouSureYouWantToCancelThePurchase" />
          </Typography>
        }
        cancelLabel="dismiss"
        confirmLabel="confirm"
        onConfirm={handleRedirectionToConfiguredUrl}
      >
        <div className={cn(getLinkColors(), 'cursor-pointer')}>
          <TenantIcon />
        </div>
      </ConfirmModal>
    );
  }

  return (
    <Link to={configuration?.webPageUrl} aria-label="Hero">
      <TenantIcon />
    </Link>
  );
};

export default Logo;
